var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrap},[_c('div',{class:_vm.$style.iconWrap},[_c('i',{staticClass:"TC tc-icon-tishi",class:_vm.$style.icon})]),_c('div',{class:_vm.$style.txt},[_vm._t("txt")],2),_c('div',{class:_vm.$style.subTxt},[_vm._t("subTxt")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }